// import { TextMessage } from 'components/textMessage/textMessage.module';
import { ENGT_CHAT } from 'js/bot.model';
import './feedback.scss';

export const FeedbackMessageTemplate = (model) => {
	const { title, subtitle, message, messageTitle, messagePlaceholder } = model;
	const msg = message?.data?.message || subtitle;

	const feedbackTitleLabel = ENGT_CHAT.get('GENERIC_STRINGS')?.GIVE_FEEDBACKS || title;

	/* html */
	// eslint-disable-next-line no-constant-condition
	const showFeedbackTextArea = false
		? `
		<span class="engt-feedback-msg-title">
			${messageTitle}
		</span>
		<textarea class="engt-feedback-input" placeholder="${messagePlaceholder}" id="engFeedbackInput"></textarea>
	`
		: '';

	/* html */
	const messageContainerHtml = `
		<div class="engt-msg engt-msg-bot engt-msg-border-bot engt-msg-feedback">
            <p class="heading">${feedbackTitleLabel}</p>
            <p class="description">${msg}</p>
        	<feedback-stars></feedback-stars>
			${showFeedbackTextArea}
            <confirm-btn></confirm-btn>
            <skip-btn></skip-btn>
			<edit-btn></edit-btn>
        </div>
	`;

	return messageContainerHtml;
};
